import { ContactHero } from '@/components/contact/ContactHero'
import { ContactForm } from '@/components/contact/ContactForm'

export const ContactPage = () => (
  <>
    <ContactHero />
    <ContactForm />
  </>
)
